"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function BlogCtaFooter() {
  const { t } = useLanguage();

  return (
    <section className="bg-white py-12 text-center">
      <div className="mx-auto max-w-3xl px-6">
        <h4 className="mb-2 text-xl font-bold text-[#064e3b]">
          {t("blog.cta.title")}
        </h4>
        <a
          href="tel:+17863774452"
          className="mb-4 inline-block text-3xl font-extrabold text-[#047857] transition hover:text-[#ea580c]"
        >
          (786) 377-4452
        </a>
        <div>
          <Link
            to="/legal-disclaimer/"
            className="inline-block whitespace-nowrap rounded bg-[#047857] px-8 py-3 text-sm font-semibold text-white transition hover:bg-[#064e3b]"
          >
            {t("blog.cta.button")}
          </Link>
        </div>
      </div>
    </section>
  );
}